/**
 * PaywallGuard — gates gameplay routes behind the $2.99 unlock / trial.
 *
 * Wraps a page: if the pilot is paid/grandfathered/mid-trial, render
 * children. Otherwise redirect to /unlock (either the paywall or the
 * trial-start CTA depending on state).
 *
 * The trial auto-starts when a "needs_trial" pilot hits any gated
 * route — one less button they have to click to actually play.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useGameAccess from "../lib/useGameAccess";

export default function PaywallGuard({ children }) {
  const location = useLocation();
  const { snapshot, loading, allowed } = useGameAccess({ autoStartTrial: true });

  if (loading) {
    return (
      <div className="min-h-screen bg-[#05050a] text-white flex items-center justify-center">
        <div className="font-mono-cosmic text-[10px] tracking-[0.3em] uppercase text-white/50">
          Loading entitlement…
        </div>
      </div>
    );
  }
  if (!snapshot) {
    // Not authenticated — bounce to login carrying the intended URL.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!allowed) {
    return <Navigate to="/unlock" replace state={{ from: location }} />;
  }
  return children;
}
